import { Entry } from '../Entry'

export function Entry20230526() {
  return (
    <Entry title="May 26 2023 - v3.4.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13873/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
